import { videoTranscode } from './inputFile';
// 检测是否能播放, 不能播放就转码
export const videoPlay = async (inputFile, callback) => {
  return new Promise(async (resolve, reject) => {
    const isVideoTranscode = await videoTranscode(inputFile, callback);
    resolve(isVideoTranscode);
  });
};
